






import { Component, Prop, Vue } from "vue-property-decorator";

const PATHS: Record<string, string> = {
  back: "M19 12H5 M11 6l-6 6 6 6",
  next: "M5 12h14 M13 6l6 6-6 6",
  chevron: "M6 9l6 6 6-6",
  check: "M5 12.5l4.5 4.5L19 7.5",
  calendar: "M6.5 5h11a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z M8 3v4 M16 3v4 M3.5 10h17",
  book: "M6.5 5h11a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3z M12 10v6 M9 13h6",
  program: "M4 5h16v14H4z M9.5 5v14 M14.5 5v14",
  shop: "M3.5 12.5l8-8h8v8l-8 8z M15.5 8.5h.01",
  course: "M4 7h11v10H4z M15 10l5-3v10l-5-3",
  voucher: "M4 10h16v10H4z M3 7h18v3H3z M12 7v13 M12 7c-2-4-6-3-4 0 M12 7c2-4 6-3 4 0",
  card: "M6 6h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3z M3 10.5h18",
  order: "M5 8h14l-1 12H6z M9 8a3 3 0 0 1 6 0",
  message: "M4 5h16v11H9l-5 4z",
  lesson: "M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z M5 17a3 3 0 0 1 3-3h11",
  list: "M7 3.5h10v17H7z M10 8h4 M10 12h4 M10 16h4",
  report: "M7 3.5h7l4 4v13H7z M14 3.5v4h4",
  user: "M12 4.5a4 4 0 1 1 0 8a4 4 0 1 1 0-8z M4.5 20.5a7.5 7.5 0 0 1 15 0",
  lock: "M7 11h10a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2z M8 11V8a4 4 0 0 1 8 0v3",
  today: "M12 8a4 4 0 1 1 0 8a4 4 0 1 1 0-8z M12 3v2 M12 19v2 M3 12h2 M19 12h2",
  article: "M6 4h12v16H6z M9 8h6 M9 12h6 M9 16h4",
  logout: "M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4 M15 8l4 4-4 4 M19 12H9",
  play: "M8 5.5l11 6.5-11 6.5z",
  alert: "M12 3l9.5 17h-19z M12 10v4 M12 17.5v.01",
  search: "M11 4a7 7 0 1 1 0 14a7 7 0 1 1 0-14z M20 20l-3.5-3.5",
  trash: "M5 7h14 M10 7V5h4v2 M7 7l1 13h8l1-13",
  close: "M6 6l12 12 M18 6L6 18",
};

@Component
export default class CzIcon extends Vue {
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: Number, default: 20 }) size!: number;

  get path() {
    return PATHS[this.name] || "";
  }
}
